<template>
  <div class="animated fadeIn d-flex flex-column align-items-center justify-content-center">
    <div class="col-12 pt-3 pb-3 pl-4 text-center">
      <h2><i class="fas fa-qrcode"></i> QRCODE</h2>
    </div>
    <img v-if="qrCode" :src="qrCode" alt="" width="400px">
    <h3 v-else>Você já está conectado</h3>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'QrCode',
  data () {
    return {
      showAdd: false,
      qrCode: null
    }
  },
  mounted () {
    this.getQrCode()
  },
  methods: {
    onLoad () {},
    async getQrCode () {
      await AtendimentoRepository.GetQrCode()
        .then(response => {
          console.log(response)
          this.qrCode = response.data.qrCode
        })
        .catch(error => {
          console.error(error)
        })
    },
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.TiposFinalizacaoAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/QrCode/qrCode.vue